var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorialpdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22589 14.68V5.18004C5.22589 4.95099 5.31688 4.73132 5.47884 4.56936C5.64081 4.4074 5.86048 4.31641 6.08953 4.31641H16.454L22.4995 10.3619V14.68",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.454 4.31641V10.3619H22.5004",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22675 21.5913H6.95402C7.41212 21.5913 7.85146 21.4093 8.17538 21.0854C8.49931 20.7614 8.68129 20.3221 8.68129 19.864C8.68129 19.4059 8.49931 18.9666 8.17538 18.6426C7.85146 18.3187 7.41212 18.1367 6.95402 18.1367H5.22675V23.3185",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4313 23.3185C14.1184 23.3185 14.7774 23.0456 15.2633 22.5597C15.7492 22.0738 16.0222 21.4148 16.0222 20.7276C16.0222 20.0405 15.7492 19.3815 15.2633 18.8956C14.7774 18.4097 14.1184 18.1367 13.4313 18.1367H12.1358V23.3185H13.4313Z",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4995 18.1367H19.4767V23.3185",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0677 21.1602H19.4767",
    stroke: "#F14242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialpdf);
export default __webpack_public_path__ + "static/media/tutorialpdf.a63a700b.svg";
export { ForwardRef as ReactComponent };